module.exports = __webpack_public_path__ + "img/拓幻科技门头.10c06667.png";